var exports = {
  "Y": "Header__1hVsNj",
  "w": "Path__0HpZdM",
};

module.exports = exports;
